import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {MemberDomainModel} from "./member-domain-model";
import {Type} from "../../../infrastructure/type";
import type {MemberApiModel} from "./member-api-model";
import {SportDomainModel} from "../../sports/models/sport-domain-model";

export class MemberFactory extends BaseFactory {
  static injectables = [...BaseFactory.injectables];

  createDomainMap(members: Array<MemberApiModel>, type: Type, key: String, sport: SportDomainModel): Map<Number, MemberDomainModel> {
    const membersMap: Map<Number, MemberDomainModel> = new Map();

    members?.forEach((member: MemberApiModel) => {
      const memberDomainModel: MemberDomainModel = new MemberDomainModel(member, false, sport);
      membersMap.set(member.id, memberDomainModel);
    });

    return membersMap;
  }

  createMap(members: Array<MemberDomainModel>): Map<Number, MemberDomainModel> {
    const membersMap: Map<Number, MemberDomainModel> = members?.length > 0 ? new Map() : null;
    membersMap && members.forEach((member: MemberDomainModel) => membersMap.set(member.id, member));

    return membersMap;
  }
}

